var _style, _path, _path2, _g, _g2, _path3, _path4, _g3, _path5, _g4, _g5, _path6, _path7, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonGreenA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000118378411428512972720000012238013692326268037_);}\n\t.st3{fill:url(#SVGID_00000062894819517589768960000004532890569077699722_);}\n\t.st4{fill:#59595C;}\n\t.st5{fill:url(#SVGID_00000071561106668935658960000004940470589428019876_);}\n\t.st6{fill:url(#SVGID_00000072968997801248388350000010108810982845533352_);}\n\t.st7{opacity:0;fill:#FFFFFF;}\n\t.st8{opacity:3.225806e-02;fill:#F9F9F9;}\n\t.st9{opacity:6.451613e-02;fill:#F3F3F3;}\n\t.st10{opacity:9.677419e-02;fill:#EDEDED;}\n\t.st11{opacity:0.129;fill:#E7E6E7;}\n\t.st12{opacity:0.1613;fill:#E1E0E1;}\n\t.st13{opacity:0.1935;fill:#DADADB;}\n\t.st14{opacity:0.2258;fill:#D4D4D5;}\n\t.st15{opacity:0.2581;fill:#CECECE;}\n\t.st16{opacity:0.2903;fill:#C8C8C8;}\n\t.st17{opacity:0.3226;fill:#C2C2C2;}\n\t.st18{opacity:0.3548;fill:#BCBCBC;}\n\t.st19{opacity:0.3871;fill:#B6B5B6;}\n\t.st20{opacity:0.4194;fill:#B0AFB0;}\n\t.st21{opacity:0.4516;fill:#AAA9AA;}\n\t.st22{opacity:0.4839;fill:#A4A3A4;}\n\t.st23{opacity:0.5161;fill:#9D9D9E;}\n\t.st24{opacity:0.5484;fill:#979798;}\n\t.st25{opacity:0.5806;fill:#919192;}\n\t.st26{opacity:0.6129;fill:#8B8B8C;}\n\t.st27{opacity:0.6452;fill:#858486;}\n\t.st28{opacity:0.6774;fill:#7F7E80;}\n\t.st29{opacity:0.7097;fill:#79787A;}\n\t.st30{opacity:0.7419;fill:#737274;}\n\t.st31{opacity:0.7742;fill:#6D6C6D;}\n\t.st32{opacity:0.8065;fill:#676667;}\n\t.st33{opacity:0.8387;fill:#606061;}\n\t.st34{opacity:0.871;fill:#5A5A5B;}\n\t.st35{opacity:0.9032;fill:#545355;}\n\t.st36{opacity:0.9355;fill:#4E4D4F;}\n\t.st37{opacity:0.9677;fill:#484749;}\n\t.st38{fill:#424143;}\n\t.st39{fill:url(#SVGID_00000104698816078986289560000001496597562725453471_);}\n\t.st40{fill:url(#SVGID_00000034786646148423683690000015115955091876484017_);}\n\t.st41{fill:url(#SVGID_00000064348326334902218050000005718948603717179036_);}\n\t.st42{opacity:0.14;fill:#FFFFFF;}\n\t.st43{opacity:0.28;fill:#FFFFFF;}\n\t.st44{fill:url(#SVGID_00000057863840192245666050000016090879940492082576_);}\n\t.st45{fill:url(#SVGID_00000048492973894247663410000010913100244001304480_);}\n\t.st46{fill:url(#SVGID_00000016077073507952213380000001575163819684140974_);}\n\t.st47{fill:url(#SVGID_00000121991062786877260240000010177809686178452641_);}\n\t.st48{fill:url(#SVGID_00000156580719638765684660000015300562695199954853_);}\n\t.st49{fill:url(#SVGID_00000135690868903348699250000011574171823888080831_);}\n\t.st50{fill:url(#SVGID_00000061443081603642863530000003021282459273126026_);}\n\t.st51{fill:url(#SVGID_00000150815648668581581920000015561615852855897492_);}\n\t.st52{fill:url(#SVGID_00000118388546619782675400000018309579210521644682_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M795.2-941.2c0,100.4-81.4,181.8-181.8,181.8c-100.4,0-181.8-81.4-181.8-181.8 c0-100.4,81.4-181.8,181.8-181.8C713.8-1122.9,795.2-1041.6,795.2-941.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.8276,
    y1: -941.18,
    x2: 788.1066,
    y2: -941.18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#5440B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5242,
    style: {
      stopColor: "#513FAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    style: {
      stopColor: "#252E5E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M788.1-941.2c0,96.5-78.2,174.6-174.6,174.6c-96.5,0-174.6-78.2-174.6-174.6c0-96.4,78.2-174.6,174.6-174.6 C709.9-1115.8,788.1-1037.6,788.1-941.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124874709399796968380000015251726188753465276_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.0493,
    y1: -941.18,
    x2: 781.8849,
    y2: -941.18
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#725ECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002755152,
    style: {
      stopColor: "#7260CD",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06290876,
    style: {
      stopColor: "#7C7FBA",
      stopOpacity: 0.9367
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    style: {
      stopColor: "#849AA9",
      stopOpacity: 0.8696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2064,
    style: {
      stopColor: "#8AB09C",
      stopOpacity: 0.7924
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#8FC192",
      stopOpacity: 0.7023
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#92CC8A",
      stopOpacity: 0.5907
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5626,
    style: {
      stopColor: "#94D386",
      stopOpacity: 0.4343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124874709399796968380000015251726188753465276_)"
    },
    d: "M781.9-941.2 c0,93-75.4,168.4-168.4,168.4c-93,0-168.4-75.4-168.4-168.4c0-93,75.4-168.4,168.4-168.4C706.5-1109.6,781.9-1034.2,781.9-941.2z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112605895501540542410000011012760126282329253_",
    gradientUnits: "userSpaceOnUse",
    x1: 2663.572,
    y1: -9205.6768,
    x2: 3000.4077,
    y2: -9205.6768,
    gradientTransform: "matrix(-0.8755 0.4832 -0.4832 -0.8755 -1355.6998 -10369.1719)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09066583,
    style: {
      stopColor: "#2D316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    style: {
      stopColor: "#3E388B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5267,
    style: {
      stopColor: "#4A3CA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7335,
    style: {
      stopColor: "#523FAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9218,
    style: {
      stopColor: "#5440B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5440B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112605895501540542410000011012760126282329253_)"
    },
    d: "M466-859.8 c-44.9-81.4-15.4-183.9,66.1-228.8c81.4-44.9,183.9-15.4,228.8,66.1c44.9,81.4,15.4,183.9-66.1,228.8 C613.4-748.8,511-778.4,466-859.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M738.8-959c0,70.6-50.6,138-121.2,138c-70.6,0-125.9-44.8-125.9-115.4c0-70.6,58.7-130.5,129.3-130.5 S738.8-1029.7,738.8-959z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000140712113405200519320000007564262287654750643_",
    cx: 729.6892,
    cy: -1083.3553,
    r: 591.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140712113405200519320000007564262287654750643_)"
    },
    d: "M756.8-941.2 c0,79.2-64.2,143.3-143.3,143.3c-79.2,0-143.3-64.2-143.3-143.3c0-79.2,64.2-143.3,143.3-143.3 C692.6-1084.5,756.8-1020.3,756.8-941.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059283162007069230170000011783863885360737947_",
    cx: 497.7676,
    cy: -815.0944,
    r: 330.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059283162007069230170000011783863885360737947_)"
    },
    d: "M749.7-941.2 c0,75.3-61,136.3-136.3,136.3s-136.3-61-136.3-136.3c0-75.2,61-136.3,136.3-136.3S749.7-1016.4,749.7-941.2z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M728.5-933.6c0,72.3-55.8,123.5-128.1,123.5c-72.3,0-122.2-72.5-116.2-132.7 c6.1-60.1,48.1-109.4,120.4-109.4C676.9-1052.1,728.5-1005.8,728.5-933.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M728-934.2c0,71.8-55.3,123.2-127.1,123.2c-71.8,0-121.6-71.4-115.7-131.4 c5.9-60,48.1-109.3,119.9-109.3C676.8-1051.7,728-1005.9,728-934.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M727.5-934.8c0,71.3-54.9,122.8-126.2,122.8c-71.3,0-120.9-70.2-115.3-130.2 c5.7-60,48-109.2,119.4-109.2C676.8-1051.3,727.5-1006.1,727.5-934.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M727-935.4c0,70.8-54.4,122.4-125.2,122.4c-70.8,0-120.3-69-114.8-128.9c5.5-59.9,48-109.1,118.8-109.1 C676.7-1050.9,727-1006.2,727-935.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M726.6-936c0,70.3-53.9,122-124.2,122C532-814,482.7-881.8,488-941.6c5.3-59.8,48-108.9,118.3-108.9 C676.7-1050.5,726.6-1006.3,726.6-936z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M726.1-936.6c0,69.8-53.4,121.6-123.3,121.6c-69.8,0-118.9-66.7-113.9-126.3 c5.1-59.7,48-108.8,117.8-108.8C676.6-1050.1,726.1-1006.4,726.1-936.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M725.6-937.2c0,69.3-52.9,121.2-122.3,121.2C534-815.9,485-881.4,489.9-941 c4.9-59.6,48-108.7,117.3-108.7C676.6-1049.7,725.6-1006.5,725.6-937.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M725.1-937.8c0,68.9-52.5,120.9-121.3,120.9c-68.9,0-117.6-64.3-112.9-123.8 c4.7-59.5,48-108.6,116.8-108.6C676.5-1049.3,725.1-1006.6,725.1-937.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M724.6-938.4c0,68.4-52,120.5-120.4,120.5c-68.4,0-117-63.2-112.5-122.5 c4.5-59.4,47.9-108.4,116.3-108.4C676.5-1048.9,724.6-1006.7,724.6-938.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M724.1-939c0,67.9-51.5,120.1-119.4,120.1c-67.9,0-116.3-62-112-121.3c4.3-59.3,47.9-108.3,115.8-108.3 C676.4-1048.5,724.1-1006.8,724.1-939z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M723.6-939.6c0,67.4-51,119.7-118.4,119.7c-67.4,0-115.6-60.8-111.5-120C497.8-999,541.6-1048,609-1048 C676.4-1048,723.6-1007,723.6-939.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M723.2-940.2c0,66.9-50.5,119.3-117.4,119.3c-66.9,0-115-59.7-111.1-118.7 c3.9-59.1,47.9-108.1,114.8-108.1C676.3-1047.6,723.2-1007.1,723.2-940.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M722.7-940.8c0,66.4-50.1,118.9-116.5,118.9c-66.4,0-114.3-58.5-110.6-117.5 c3.7-59,47.9-107.9,114.3-107.9C676.3-1047.2,722.7-1007.2,722.7-940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M722.2-941.4c0,65.9-49.6,118.6-115.5,118.6c-65.9,0-113.7-57.3-110.1-116.2 c3.5-58.9,47.8-107.8,113.8-107.8C676.2-1046.8,722.2-1007.3,722.2-941.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M721.7-942c0,65.4-49.1,118.2-114.5,118.2c-65.4,0-113-56.1-109.7-114.9 c3.3-58.8,47.8-107.7,113.3-107.7C676.2-1046.4,721.7-1007.4,721.7-942z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M721.2-942.6c0,64.9-48.6,117.8-113.6,117.8c-64.9,0-112.3-55-109.2-113.7 c3.1-58.7,47.8-107.6,112.7-107.6C676.1-1046,721.2-1007.5,721.2-942.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M720.7-943.2c0,64.5-48.1,117.4-112.6,117.4c-64.5,0-111.7-53.8-108.8-112.4 c2.9-58.6,47.8-107.4,112.2-107.4C676.1-1045.6,720.7-1007.6,720.7-943.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M720.2-943.8c0,64-47.7,117-111.6,117c-64,0-111-52.6-108.3-111.1c2.7-58.5,47.8-107.3,111.7-107.3 C676-1045.2,720.2-1007.8,720.2-943.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M719.7-944.4c0,63.5-47.2,116.6-110.7,116.6c-63.5,0-110.4-51.5-107.8-109.9 c2.5-58.4,47.7-107.2,111.2-107.2C676-1044.8,719.7-1007.9,719.7-944.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M719.3-945c0,63-46.7,116.3-109.7,116.3c-63,0-109.7-50.3-107.4-108.6c2.3-58.3,47.7-107.1,110.7-107.1 C675.9-1044.4,719.3-1008,719.3-945z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M718.8-945.6c0,62.5-46.2,115.9-108.7,115.9c-62.5,0-109-49.1-106.9-107.3 c2.2-58.2,47.7-106.9,110.2-106.9C675.9-1044,718.8-1008.1,718.8-945.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M718.3-946.2c0,62-45.7,115.5-107.8,115.5c-62,0-108.4-47.9-106.4-106c2-58.1,47.7-106.8,109.7-106.8 C675.8-1043.5,718.3-1008.2,718.3-946.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M717.8-946.8c0,61.5-45.3,115.1-106.8,115.1c-61.5,0-107.7-46.8-106-104.8 c1.8-58,47.7-106.7,109.2-106.7C675.8-1043.1,717.8-1008.3,717.8-946.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M717.3-947.4c0,61-44.8,114.7-105.8,114.7c-61,0-107.1-45.6-105.5-103.5 c1.6-57.9,47.6-106.6,108.7-106.6S717.3-1008.4,717.3-947.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M716.8-948c0,60.5-44.3,114.3-104.8,114.3c-60.5,0-106.4-44.4-105-102.2 c1.4-57.8,47.6-106.4,108.2-106.4C675.7-1042.3,716.8-1008.5,716.8-948z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M716.3-948.6c0,60.1-43.8,114-103.9,114c-60.1,0-105.7-43.3-104.6-101c1.2-57.7,47.6-106.3,107.7-106.3 C675.6-1041.9,716.3-1008.7,716.3-948.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M715.9-949.2c0,59.6-43.3,113.6-102.9,113.6c-59.6,0-105.1-42.1-104.1-99.7 c1-57.6,47.6-106.2,107.2-106.2C675.6-1041.5,715.9-1008.8,715.9-949.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M715.4-949.8c0,59.1-42.9,113.2-101.9,113.2c-59.1,0-104.4-40.9-103.6-98.4 c0.8-57.5,47.6-106.1,106.6-106.1C675.5-1041.1,715.4-1008.9,715.4-949.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M714.9-950.4c0,58.6-42.4,112.8-101,112.8c-58.6,0-103.8-39.7-103.2-97.2 c0.6-57.4,47.5-105.9,106.1-105.9C675.5-1040.7,714.9-1009,714.9-950.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M714.4-951c0,58.1-41.9,112.4-100,112.4c-58.1,0-103.1-38.6-102.7-95.9 c0.4-57.3,47.5-105.8,105.6-105.8C675.4-1040.3,714.4-1009.1,714.4-951z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M713.9-951.6c0,57.6-41.4,112-99,112c-57.6,0-102.4-37.4-102.3-94.6c0.2-57.2,47.5-105.7,105.1-105.7 C675.4-1039.9,713.9-1009.2,713.9-951.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M713.4-952.2c0,57.1-40.9,111.7-98.1,111.7c-57.1,0-101.8-36.2-101.8-93.4 c0-57.1,47.5-105.5,104.6-105.5C675.3-1039.5,713.4-1009.3,713.4-952.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018222222148389288210000016863526937422641585_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.4259,
    y1: -941.1786,
    x2: 728.5057,
    y2: -941.1786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#5440B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5242,
    style: {
      stopColor: "#513FAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    style: {
      stopColor: "#252E5E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018222222148389288210000016863526937422641585_)"
    },
    d: "M728.5-941.2 c0,63.5-51.5,115-115,115c-63.5,0-115-51.5-115-115c0-63.5,51.5-115,115-115C677-1056.2,728.5-1004.7,728.5-941.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094613368414923692500000017339518231490348420_",
    gradientUnits: "userSpaceOnUse",
    x1: 4048.2759,
    y1: -8060.0542,
    x2: 4261.6733,
    y2: -8060.0542,
    gradientTransform: "matrix(-0.619 0.7854 -0.7854 -0.619 -3143.8962 -9195.6465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002702703,
    style: {
      stopColor: "#37A400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02621373,
    style: {
      stopColor: "#42AA0F",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08469747,
    style: {
      stopColor: "#58B52E",
      stopOpacity: 0.9173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    style: {
      stopColor: "#6BBF4A",
      stopOpacity: 0.8505
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    style: {
      stopColor: "#7BC760",
      stopOpacity: 0.7749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3134,
    style: {
      stopColor: "#87CD71",
      stopOpacity: 0.6868
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4216,
    style: {
      stopColor: "#8FD27C",
      stopOpacity: 0.5777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#94D483",
      stopOpacity: 0.4247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000094613368414923692500000017339518231490348420_)"
    },
    cx: 614,
    cy: -943,
    r: 106.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129893594184911910120000011462279329015633538_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.2927,
    y1: -942.978,
    x2: 720.699,
    y2: -942.978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5440B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#252E5E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000129893594184911910120000011462279329015633538_)"
    },
    cx: 614,
    cy: -943,
    r: 106.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M531.1-968.3c36.5-46.3,103.6-54.2,149.9-17.8c17.2,13.6,29.1,31.4,35.4,50.7c3.2-33.4-10.1-67.6-38.4-89.9 c-44.2-34.9-108.3-27.3-143.2,17c-16.9,21.5-23.8,47.6-21.4,72.8C517.2-947,523.1-958.1,531.1-968.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M694.8-881.6c-34.8,44.2-98.9,51.8-143.1,16.9c-22.7-17.9-35.7-43.4-38.3-70c1.4,27.9,14.4,55.1,38.1,73.8 c43.5,34.3,106.6,26.8,140.9-16.7c3.4-4.3,6.3-8.7,8.9-13.3C699.3-887.7,697.1-884.6,694.8-881.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 639,
    height: 714,
    xlinkHref: "D1B880B6.png",
    transform: "matrix(0.24 0 0 0.24 539.6882 -1021.0318)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.5-1001.2h55.7c13.7,0,24.5,3.8,31.4,10.6c5.5,5.5,8.2,12.2,8.2,20.4v0.3c0,13.5-7.2,21.1-15.8,25.9 c13.9,5.3,22.5,13.4,22.5,29.5v0.3c0,21.9-17.8,32.9-44.9,32.9h-57.1V-1001.2z M612.5-952.7c11.7,0,19-3.8,19-12.7v-0.3 c0-7.9-6.2-12.3-17.3-12.3h-26.1v25.4H612.5z M619.6-904.3c11.7,0,18.7-4.1,18.7-13v-0.3c0-8.1-6-13-19.5-13h-30.5v26.4H619.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366,184.2C366,284.6,284.7,366,184.3,366C83.9,366,2.5,284.6,2.5,184.2C2.5,83.8,83.9,2.5,184.3,2.5 C284.7,2.5,366,83.8,366,184.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060743732359315343980000003160280687252836795_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.6378,
    y1: 184.2182,
    x2: 358.9168,
    y2: 184.2182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E8100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#7BB61A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E8100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060743732359315343980000003160280687252836795_)"
    },
    d: "M358.9,184.2 c0,96.5-78.2,174.6-174.6,174.6c-96.5,0-174.6-78.2-174.6-174.6C9.6,87.8,87.8,9.6,184.3,9.6C280.7,9.6,358.9,87.8,358.9,184.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160157763860292974240000015482044531024363164_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8595,
    y1: 184.2182,
    x2: 352.6952,
    y2: 184.2182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#725ECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002755152,
    style: {
      stopColor: "#7260CD",
      stopOpacity: 0.9972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06290876,
    style: {
      stopColor: "#7C7FBA",
      stopOpacity: 0.9367
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1297,
    style: {
      stopColor: "#849AA9",
      stopOpacity: 0.8696
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2064,
    style: {
      stopColor: "#8AB09C",
      stopOpacity: 0.7924
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#8FC192",
      stopOpacity: 0.7023
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#92CC8A",
      stopOpacity: 0.5907
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5626,
    style: {
      stopColor: "#94D386",
      stopOpacity: 0.4343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160157763860292974240000015482044531024363164_)"
    },
    d: "M352.7,184.2 c0,93-75.4,168.4-168.4,168.4c-93,0-168.4-75.4-168.4-168.4c0-93,75.4-168.4,168.4-168.4C277.3,15.8,352.7,91.2,352.7,184.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120527362686381202450000004236463749740240780_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.8295,
    y1: 184.2166,
    x2: 352.7263,
    y2: 184.2166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6EAF19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#BCFF32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120527362686381202450000004236463749740240780_)"
    },
    d: "M36.8,265.6 C-8.1,184.2,21.5,81.7,102.9,36.8c81.4-44.9,183.9-15.4,228.8,66.1c44.9,81.4,15.4,183.9-66.1,228.8 C184.2,376.6,81.8,347,36.8,265.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309.6,166.4c0,70.6-50.6,138-121.2,138c-70.6,0-125.9-44.8-125.9-115.4c0-70.6,58.7-130.5,129.3-130.5 S309.6,95.7,309.6,166.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000017475098535120382730000015451859689699948727_",
    cx: 300.4994,
    cy: 42.0428,
    r: 591.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017475098535120382730000015451859689699948727_)"
    },
    d: "M327.6,184.2 c0,79.2-64.2,143.3-143.3,143.3c-79.2,0-143.3-64.2-143.3-143.3c0-79.2,64.2-143.3,143.3-143.3 C263.4,40.9,327.6,105.1,327.6,184.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000025441302946945657130000007072499247302290834_",
    cx: 68.5778,
    cy: 310.3037,
    r: 330.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6624,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEAEAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025441302946945657130000007072499247302290834_)"
    },
    d: "M320.5,184.2 c0,75.3-61,136.3-136.3,136.3S48,259.5,48,184.2C48,109,109,48,184.3,48S320.5,109,320.5,184.2z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.3,191.8c0,72.3-55.8,123.5-128.1,123.5C98.9,315.4,49,242.8,55,182.7 c6.1-60.1,48.1-109.4,120.4-109.4C247.7,73.3,299.3,119.6,299.3,191.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M298.8,191.2c0,71.8-55.3,123.2-127.1,123.2C99.9,314.4,50.1,243,56,183c5.9-60,48.1-109.3,119.9-109.3 C247.6,73.7,298.8,119.5,298.8,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M298.3,190.6c0,71.3-54.9,122.8-126.2,122.8c-71.3,0-120.9-70.2-115.3-130.2 c5.7-59.9,48-109.2,119.4-109.2C247.6,74.1,298.3,119.3,298.3,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M297.9,190c0,70.8-54.4,122.4-125.2,122.4c-70.8,0-120.3-69-114.8-128.9c5.5-59.9,48-109.1,118.8-109.1 C247.5,74.5,297.9,119.2,297.9,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M297.4,189.4c0,70.3-53.9,122-124.2,122c-70.3,0-119.6-67.9-114.3-127.6c5.3-59.8,48-108.9,118.3-108.9 C247.5,74.9,297.4,119.1,297.4,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M296.9,188.8c0,69.8-53.4,121.6-123.3,121.6c-69.8,0-118.9-66.7-113.9-126.3 c5.1-59.7,48-108.8,117.8-108.8C247.4,75.3,296.9,119,296.9,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M296.4,188.2c0,69.3-52.9,121.2-122.3,121.2c-69.3,0-118.3-65.5-113.4-125.1 c4.9-59.6,48-108.7,117.3-108.7C247.4,75.7,296.4,118.9,296.4,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M295.9,187.6c0,68.9-52.5,120.9-121.3,120.9c-68.9,0-117.6-64.3-112.9-123.8 c4.7-59.5,48-108.6,116.8-108.6C247.3,76.1,295.9,118.8,295.9,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M295.4,187c0,68.4-52,120.5-120.4,120.5c-68.4,0-117-63.2-112.5-122.5c4.5-59.4,47.9-108.4,116.3-108.4 C247.3,76.5,295.4,118.7,295.4,187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294.9,186.4c0,67.9-51.5,120.1-119.4,120.1c-67.9,0-116.3-62-112-121.3 C67.9,126,111.5,76.9,179.3,76.9C247.2,76.9,294.9,118.5,294.9,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M294.5,185.8c0,67.4-51,119.7-118.4,119.7c-67.4,0-115.6-60.8-111.5-120 c4.1-59.2,47.9-108.2,115.3-108.2C247.2,77.4,294.5,118.4,294.5,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M294,185.2c0,66.9-50.5,119.3-117.4,119.3c-66.9,0-115-59.7-111.1-118.7 c3.9-59.1,47.9-108.1,114.8-108.1C247.1,77.8,294,118.3,294,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M293.5,184.6c0,66.4-50.1,118.9-116.5,118.9c-66.4,0-114.3-58.5-110.6-117.5 c3.7-59,47.9-107.9,114.3-107.9C247.1,78.2,293.5,118.2,293.5,184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M293,184c0,65.9-49.6,118.6-115.5,118.6c-65.9,0-113.7-57.3-110.1-116.2 c3.5-58.9,47.8-107.8,113.8-107.8C247,78.6,293,118.1,293,184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M292.5,183.4c0,65.4-49.1,118.2-114.5,118.2c-65.4,0-113-56.1-109.7-114.9 C71.6,127.9,116.1,79,181.5,79C247,79,292.5,118,292.5,183.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M292,182.8c0,64.9-48.6,117.8-113.6,117.8c-64.9,0-112.3-55-109.2-113.7C72.4,128.3,117,79.4,182,79.4 C246.9,79.4,292,117.9,292,182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M291.5,182.2c0,64.5-48.1,117.4-112.6,117.4c-64.5,0-111.7-53.8-108.8-112.4 C73.1,128.7,118,79.8,182.4,79.8C246.9,79.8,291.5,117.8,291.5,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M291,181.6c0,64-47.7,117-111.6,117c-64,0-111-52.6-108.3-111.1C73.9,129,118.9,80.2,182.9,80.2 C246.8,80.2,291,117.6,291,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M290.6,181c0,63.5-47.2,116.6-110.7,116.6c-63.5,0-110.4-51.5-107.8-109.9 c2.5-58.4,47.7-107.2,111.2-107.2C246.8,80.6,290.6,117.5,290.6,181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M290.1,180.4c0,63-46.7,116.3-109.7,116.3c-63,0-109.7-50.3-107.4-108.6C75.4,129.8,120.7,81,183.7,81 C246.7,81,290.1,117.4,290.1,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M289.6,179.8c0,62.5-46.2,115.9-108.7,115.9c-62.5,0-109-49.1-106.9-107.3 c2.2-58.2,47.7-106.9,110.2-106.9C246.7,81.4,289.6,117.3,289.6,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M289.1,179.2c0,62-45.7,115.5-107.8,115.5c-62,0-108.4-47.9-106.4-106c2-58.1,47.7-106.8,109.7-106.8 C246.6,81.9,289.1,117.2,289.1,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M288.6,178.6c0,61.5-45.3,115.1-106.8,115.1c-61.5,0-107.7-46.8-106-104.8 c1.8-58,47.7-106.7,109.2-106.7C246.6,82.3,288.6,117.1,288.6,178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M288.1,178c0,61-44.8,114.7-105.8,114.7c-61,0-107.1-45.6-105.5-103.5c1.6-57.9,47.6-106.6,108.7-106.6 S288.1,117,288.1,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M287.6,177.4c0,60.5-44.3,114.3-104.8,114.3c-60.5,0-106.4-44.4-105-102.2 c1.4-57.8,47.6-106.4,108.2-106.4C246.5,83.1,287.6,116.9,287.6,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M287.2,176.8c0,60.1-43.8,114-103.9,114c-60.1,0-105.7-43.3-104.6-101c1.2-57.7,47.6-106.3,107.7-106.3 C246.4,83.5,287.2,116.7,287.2,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M286.7,176.2c0,59.6-43.3,113.6-102.9,113.6c-59.6,0-105.1-42.1-104.1-99.7 c1-57.6,47.6-106.2,107.2-106.2C246.4,83.9,286.7,116.6,286.7,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M286.2,175.6c0,59.1-42.9,113.2-101.9,113.2c-59.1,0-104.4-40.9-103.6-98.4 c0.8-57.5,47.6-106.1,106.6-106.1C246.3,84.3,286.2,116.5,286.2,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M285.7,175c0,58.6-42.4,112.8-101,112.8c-58.6,0-103.8-39.7-103.2-97.2 c0.6-57.4,47.5-105.9,106.1-105.9C246.3,84.7,285.7,116.4,285.7,175z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M285.2,174.4c0,58.1-41.9,112.4-100,112.4c-58.1,0-103.1-38.6-102.7-95.9 C82.9,133.6,130,85.1,188.1,85.1C246.2,85.1,285.2,116.3,285.2,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M284.7,173.8c0,57.6-41.4,112-99,112c-57.6,0-102.4-37.4-102.3-94.6C83.6,134,130.9,85.5,188.6,85.5 C246.2,85.5,284.7,116.2,284.7,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M284.2,173.2c0,57.1-40.9,111.7-98.1,111.7c-57.1,0-101.8-36.2-101.8-93.4 c0-57.1,47.5-105.5,104.6-105.5C246.1,85.9,284.2,116.1,284.2,173.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123436499637299303760000017337668268984297122_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.2361,
    y1: 184.2195,
    x2: 299.3159,
    y2: 184.2195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E8100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#7BB61A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E8100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123436499637299303760000017337668268984297122_)"
    },
    d: "M299.3,184.2 c0,63.5-51.5,115-115,115c-63.5,0-115-51.5-115-115c0-63.5,51.5-115,115-115C247.8,69.2,299.3,120.7,299.3,184.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003097480847261933850000013789621084361610932_",
    gradientUnits: "userSpaceOnUse",
    x1: 5197.8013,
    y1: -8419.6602,
    x2: 5411.1987,
    y2: -8419.6602,
    gradientTransform: "matrix(-0.619 0.7854 -0.7854 -0.619 -3143.8962 -9195.6465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002702703,
    style: {
      stopColor: "#37A400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02621373,
    style: {
      stopColor: "#42AA0F",
      stopOpacity: 0.9763
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08469747,
    style: {
      stopColor: "#58B52E",
      stopOpacity: 0.9173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    style: {
      stopColor: "#6BBF4A",
      stopOpacity: 0.8505
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    style: {
      stopColor: "#7BC760",
      stopOpacity: 0.7749
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3134,
    style: {
      stopColor: "#87CD71",
      stopOpacity: 0.6868
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4216,
    style: {
      stopColor: "#8FD27C",
      stopOpacity: 0.5777
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#94D483",
      stopOpacity: 0.4247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#95D585",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000003097480847261933850000013789621084361610932_)"
    },
    cx: 184.8,
    cy: 182.4,
    r: 106.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157309151205486325630000009912533493575156613_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.1029,
    y1: 182.4201,
    x2: 291.5092,
    y2: 182.4201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6EAF19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#BCFF32"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000157309151205486325630000009912533493575156613_)"
    },
    cx: 184.8,
    cy: 182.4,
    r: 106.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M101.9,157.1c36.5-46.3,103.6-54.2,149.9-17.8c17.2,13.6,29.1,31.4,35.4,50.7c3.2-33.4-10.1-67.6-38.4-89.9 c-44.2-34.9-108.3-27.3-143.2,17c-16.9,21.5-23.8,47.6-21.4,72.8C88,178.4,93.9,167.3,101.9,157.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M265.6,243.8c-34.8,44.2-98.9,51.8-143.1,16.9c-22.7-17.9-35.7-43.4-38.3-70c1.4,27.9,14.4,55.1,38.1,73.8 c43.5,34.3,106.6,26.8,140.9-16.7c3.4-4.3,6.3-8.7,8.9-13.3C270.1,237.7,267.9,240.8,265.6,243.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157993323613183998330000008719335828005955716_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.4284,
    y1: 186.6274,
    x2: 248.7399,
    y2: 186.6274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E8100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#7BB61A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E8100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157993323613183998330000008719335828005955716_)"
    },
    d: "M210.2,225.9h-48.3l-9.2,27.5h-29.3 l49.8-133.7h25.5l50,133.7h-29.3L210.2,225.9z M169.3,203.6h33.4l-16.8-50L169.3,203.6z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.6,221.1h-48.3l-9.2,27.5h-29.3L169.6,115h25.5l50,133.7h-29.3L206.6,221.1z M165.7,198.8h33.4l-16.8-50 L165.7,198.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGreenA);
export default __webpack_public_path__ + "static/media/button-green-a.5fbf865a58c3aba4dab73a57a6aecfb4.svg";
export { ForwardRef as ReactComponent };